import {
  ArrowUpIcon,
  AttachmentIcon,
  CloseIcon,
} from "@chakra-ui/icons";
import {
  Box,
  Flex,
  IconButton,
  Image,
  ListItem,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Textarea,
  Tabs,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { decryptResponse } from "../../../allApi/interceptorsApiCall";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiClient from "../../../allApi/interceptorsApiCall";
import csvIcon from "../../../assets/waveflowmain/filesIcon/csv.png";
import docIcon from "../../../assets/waveflowmain/filesIcon/doc.png";
import jsIcon from "../../../assets/waveflowmain/filesIcon/js.png";
import jsonIcon from "../../../assets/waveflowmain/filesIcon/json.png";
import pdfIcon from "../../../assets/waveflowmain/filesIcon/pdf.png";
import pyIcon from "../../../assets/waveflowmain/filesIcon/py.png";
import txtIcon from "../../../assets/waveflowmain/filesIcon/txt.png";
import MarkdownRenderer from "../../../components/stringtomarkdown/Stringtomarkdown";
import {
  addfinalanswerFun,
  addfinalanswerLoadingFun,
} from "../../../redux/reducer/agentcanvas";
import LoadingForEnterprise from "./LoadingForEnterprise.jsx";
import { commonStyle } from "../../../styles/commonStyle.js";
import { useCustomTost } from "../../../utiils/useCustomTost";

function DetailsShow() {
  const printRef = useRef();
  const waveflowRef = useRef();
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const toast = useCustomTost();
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [files, setFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [queChat, setQueChat] = useState("");

  const agentfinalAnswer = useSelector(
    (state) => state.agentcanvaReducer.finalAnswer
  );
  const agentfinalAnswerLoading = useSelector(
    (state) => state.agentcanvaReducer.addfinalanswerLoading
  );

  const getFileIcon = (fileName) => {
    if (!fileName) return pdfIcon;
    const extension = fileName?.split(".")?.pop()?.toLowerCase();
    const icons = {
      pdf: pdfIcon,
      doc: docIcon,
      docx: docIcon,
      py: pyIcon,
      js: jsIcon,
      txt: txtIcon,
      csv: csvIcon,
      json: jsonIcon,
    };
    return icons[extension] || pdfIcon;
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await apiClient.post("/file", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
      });

      const data = decryptResponse(response.data);

      if (data?.status === "uploaded") {
        setUploadedFiles((prev) => [...prev, data.filename]);
        return true;
      }
      return false;
    } catch (error) {
      toast(
        "Error",
        decryptResponse(error?.response?.data?.error) ||
          `Failed to upload ${file.name}`,
        "error"
      );
      return false;
    } finally {
      setUploadProgress(0);
    }
  };

  const handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);

    if (!selectedFiles || selectedFiles.length === 0) return;

    const remainingSlots = 10 - files.length;
    if (remainingSlots <= 0) {
      toast("Warning", "Maximum 10 files allowed", "warning");
      return;
    }

    const filesToProcess = selectedFiles.slice(0, remainingSlots);

    if (selectedFiles.length > remainingSlots) {
      toast(
        "Warning",
        `Only ${remainingSlots} more files can be added`,
        "warning"
      );
    }

    setFiles((prev) => [...prev, ...filesToProcess]);
    setIsLoading(true);

    try {
      for (const file of filesToProcess) {
        const success = await uploadFile(file);

        if (!success) {
          setFiles((prev) => prev.filter((f) => f.name !== file.name));
        }
      }
    } catch (_error) {
      toast("Error", "Failed to process uploads", "error");
    } finally {
      setIsLoading(false);
      e.target.value = "";
    }
  };

  const handleDeleteFile = (index) => {
    const fileToRemove = files[index];
    setFiles((prev) => prev.filter((_, i) => i !== index));

    if (fileToRemove) {
      setUploadedFiles((prev) =>
        prev.filter((fileName) => fileName !== fileToRemove.name)
      );
    }
  };

  const sendChatQuery = async (question) => {
    const formData = new FormData();
    formData.append("query", question);

    if (uploadedFiles.length > 0) {
      formData.append("filenames", JSON.stringify(uploadedFiles));
    }

    dispatch(addfinalanswerLoadingFun(true));
    try {
      const res = await apiClient.post("/chat_pdf", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const answer = decryptResponse(res?.data);
      dispatch(addfinalanswerFun(answer));
    } catch (_error) {
      toast("Error", "Sorry, I couldn't process your request.", "error");
    } finally {
      dispatch(addfinalanswerLoadingFun(false));
    }
  };

  const handleSubmit = () => {
    if (!queChat.trim()) return;
    sendChatQuery(queChat);
    setQueChat("");
    if (waveflowRef.current) {
      waveflowRef.current.style.height = "45px";
    }
  };

  const handleQueryWaveFlow = (e) => {
    setQueChat(e.target.value);

    const textarea = waveflowRef.current;
    if (textarea) {
      textarea.style.height = "45px";
      textarea.style.height = `${Math.min(textarea.scrollHeight, 150)}px`;
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Box w={"100%"} h={"100%"} display="flex" flexDirection="column">
      <Tabs w={"100%"} flex={1} minH={0} display="flex" flexDirection="column">
        <TabList>
          <Tab sx={{ fontSize: "14px", padding: "2", margin: "0" }}>
            Answer agreed by agents
          </Tab>
          <Tab sx={{ fontSize: "14px", padding: "2", margin: "0" }}>
            Discussion logs
          </Tab>
          <Tab sx={{ fontSize: "14px", padding: "2", margin: "0" }}>
            Citations
          </Tab>
        </TabList>

        <TabPanels
          flex={1}
          minH={0}
          overflowY="auto"
          sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
          p={0}
          w={"100%"}
          ref={printRef}
        >
          <TabPanel p={1}>
            <Box w={"100%"}>
              {agentfinalAnswerLoading ? (
                <LoadingForEnterprise />
              ) : (
                agentfinalAnswer?.final_answer && (
                  <Text>
                    <MarkdownRenderer
                      content={agentfinalAnswer?.final_answer}
                    />
                  </Text>
                )
              )}
            </Box>
          </TabPanel>
          <TabPanel>
            <Box p={4} w={"100%"}>
              <MarkdownRenderer content={agentfinalAnswer?.conversation} />
            </Box>
          </TabPanel>
          <TabPanel>
            <MarkdownRenderer content={agentfinalAnswer?.citation} />
          </TabPanel>
        </TabPanels>
      </Tabs>

      <Box w="100%" mt={2} flexShrink={0}>
        <Box alignItems="flex-start" w={"100%"}>
          {files?.length > 0 && <Text fontWeight="bold">Uploaded Files:</Text>}
          {files?.length > 0 && (
            <UnorderedList
              h={"90px"}
              styleType="disc"
              ml={4}
              overflowY="auto"
              sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
            >
              {files.map((file, idx) => (
                <ListItem
                  textAlign="left"
                  key={idx}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box display="flex" alignItems="center">
                    <Image
                      src={getFileIcon(file?.name)}
                      alt="File Icon"
                      boxSize={"20px"}
                      mr={2}
                    />
                    {file.name}
                    {uploadedFiles.includes(file.name) && (
                      <Text fontSize="xs" ml={2} color="green.500">
                        (Uploaded)
                      </Text>
                    )}
                  </Box>
                  <IconButton
                    icon={<CloseIcon />}
                    size="sm"
                    aria-label="Delete file"
                    onClick={() => handleDeleteFile(idx)}
                  />
                </ListItem>
              ))}
            </UnorderedList>
          )}
        </Box>

        {uploadProgress > 0 && (
          <Box mb={2}>
            <Text fontSize="sm">Uploading: {uploadProgress}%</Text>
            <Box bg="gray.200" h="4px" borderRadius="md" overflow="hidden">
              <Box
                bg="#6866D3"
                h="100%"
                width={`${uploadProgress}%`}
                transition="width 0.3s"
              />
            </Box>
          </Box>
        )}

        <Flex
          border="1px solid lightgray"
          borderRadius="10px"
          bg="white"
          px={2}
          py={1}
          alignItems="flex-end"
          w="100%"
        >
          <Box>
            <input
              ref={fileInputRef}
              type="file"
              accept=".pdf, .doc, .docx, .txt, .csv, .json, .ipynb, .py"
              multiple
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <IconButton
              icon={<AttachmentIcon />}
              size="sm"
              aria-label="Attach"
              onClick={() => fileInputRef.current?.click()}
              isDisabled={isLoading}
              variant="ghost"
              mb={1}
            />
          </Box>

          <Textarea
            ref={waveflowRef}
            value={queChat}
            onChange={handleQueryWaveFlow}
            placeholder="What would you like to know?"
            focusBorderColor="transparent"
            _focus={{ boxShadow: "none" }}
            border="none"
            resize="none"
            minH="40px"
            maxH="150px"
            overflowY="auto"
            lineHeight="1.5"
            onKeyDown={handleKeyDown}
            mx={2}
            flex={1}
          />

          <Box>
            <IconButton
              icon={<ArrowUpIcon />}
              aria-label="Send"
              size="sm"
              bg="#6866D3"
              color="white"
              borderRadius="full"
              _hover={{ bg: "#5755c9" }}
              onClick={handleSubmit}
              mb={1}
              isDisabled={agentfinalAnswerLoading}
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
}

export default DetailsShow;
